import React, { FC } from 'react';
import Head from 'next/head';

export const Title: FC<{ title: string }> = ({ title }) => (
  <Head>
    <title>{title}</title>
  </Head>
);
